import type { PluginDefaultTranslationsObject, PluginLanguage } from '../types.js'

export const ptTranslations: PluginDefaultTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-form-builder': {
    name: 'Nome (minúsculas, sem caracteres especiais)',
    add: 'Adicionar',
    allowedFileTypes: 'Tipos de arquivos permitidos',
    allowedFileTypesDescription:
      'Restrinja os tipos de arquivo permitidos (por exemplo, imagem/*, aplicativo/pdf). Deixe em branco para permitir todos os tipos.',
    allowMultipleFiles: 'Permitir vários arquivos',
    amountInCents: 'Valor em centavos',
    basePrice: 'Preço Base',
    bcc: 'CCO',
    brand: 'Marca',
    cc: 'CC',
    checkboxPlural: 'Campos de caixa de seleção',
    checkboxSingular: 'Caixa de seleção',
    checkedByDefault: 'Verificado por padrão',
    chooseConfirmationType:
      'Escolha se deseja exibir uma mensagem na página ou redirecionar para uma página diferente após enviar o formulário.',
    condition: 'Condição',
    confirmationMessage: 'Mensagem de confirmação',
    confirmationType: 'Tipo de confirmação',
    countryPlural: 'Campos de país',
    countrySingular: 'País',
    creditCard: 'Cartão de crédito',
    customURL: 'URL personalizado',
    datePlural: 'Campos de data',
    dateSingular: 'Data',
    defaultValue: 'Valor padrão',
    divide: 'Dividir',
    documentToLinkTo: 'Documento para vincular',
    doesNotEqual: 'Não é igual',
    emailFrom: 'E-mail de',
    emailPlural: 'Campos de e-mail',
    emailsDescription:
      'Envie e-mails personalizados quando o formulário for enviado. Use listas separadas por vírgulas para enviar o mesmo e-mail para vários destinatários. Para fazer referência a um valor deste formulário, coloque o nome desse campo entre chaves duplas, ou seja, {{firstName}}. Você pode usar um curinga {{*}} para gerar todos os dados e {{*:table}} para formatá-los como uma tabela HTML no e-mail.',
    emailSingular: 'E-mail',
    emailTo: 'E-mail para',
    equals: 'Igual',
    field: 'Campo',
    fields: 'Campos',
    fieldWidth: 'Largura do campo (porcentagem)',
    hasAnyValue: 'Tem qualquer valor',
    internalLink: 'Link interno',
    label: 'Etiqueta',
    maxFileSize: 'Tamanho máximo do arquivo (bytes)',
    maxFileSizeDescription: 'Tamanho máximo do arquivo em bytes. Deixe em branco sem limite.',
    message: 'Mensagem',
    messageDescription: 'Digite a mensagem que deve ser enviada neste e-mail.',
    messagePlural: 'Blocos de mensagens',
    messageSingular: 'Mensagem',
    mimeType: 'Tipo MIME',
    mimeTypePlural: 'Tipos MIME',
    mimeTypeSingular: 'Tipo MIME',
    multiply: 'Multiplicar',
    numberPlural: 'Campos numéricos',
    numberSingular: 'Número',
    optionPlural: 'Opções',
    optionSingular: 'Opção',
    paymentFieldPlural: 'Campos de pagamento',
    paymentFieldSingular: 'Pagamento',
    paymentProcessor: 'Processador de pagamento',
    paymentStatus: 'Estado',
    placeholder: 'Espaço reservado',
    priceConditions: 'Condições de Preço',
    priceConditionsPlural: 'Condições de Preço',
    priceConditionsSingular: 'Condição de preço',
    radioOptions: 'Opções de atributos de rádio',
    radioPlural: 'Campos de Rádio',
    radioSingular: 'Rádio',
    redirect: 'Redirecionar',
    replyTo: 'Responder para',
    required: 'Obrigatório',
    selectOptions: 'Selecione Opções',
    selectPlural: 'Selecione os campos',
    selectSingular: 'Selecione',
    statePlural: 'Campos estaduais',
    stateSingular: 'Estado',
    staticValue: 'Valor estático',
    subject: 'Assunto',
    submitButton: 'Etiqueta do botão Enviar',
    subtract: 'Subtrair',
    textareaPlural: 'Campos de área de texto',
    textareaSingular: 'Área de texto',
    textPlural: 'Campos de texto',
    textSingular: 'Texto',
    title: 'Título',
    token: 'ficha',
    uploadCollection: 'Carregar coleção',
    uploadCollectionDescription:
      'Selecione em qual coleção de upload os arquivos serão armazenados',
    uploadFieldPlural: 'Carregar campos',
    uploadFieldSingular: 'Carregar',
    urlToRedirectTo: 'URL para redirecionar',
    value: 'Valor',
    valueOfField: 'Valor do campo',
    valueType: 'Tipo de valor',
  },
}

export const pt: PluginLanguage = {
  dateFNSKey: 'pt',
  translations: ptTranslations,
}
